import React from 'react';
import { styles } from './DynamicCarouselCover.css';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
export enum DynamicCarouselCoverTheme {
  light = 'light',
  dark = 'dark',
}

export type DynamicCarouselCoverProps = {
  coverImageUrl: string;
  coverImageAlt: string;
  heading: string;
  content: string;
  isWhiteSubText?: boolean;
  theme?: DynamicCarouselCoverTheme;
};
export const DynamicCarouselCover = ({
  coverImageUrl,
  coverImageAlt,
  heading,
  content,
  isWhiteSubText,
  theme = DynamicCarouselCoverTheme.dark,
}: DynamicCarouselCoverProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        <DomFont as="h2" className={styles.heading({ theme })}>
          {heading}
        </DomFont>
        <p className={styles.content({ theme, isWhiteSubText })}>{content}</p>
      </div>
      <div className={styles.imageContainer}>
        <img className={styles.image} src={coverImageUrl} alt={coverImageAlt} />
      </div>
    </div>
  );
};
